import { FormEvent, ReactElement, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Layout } from "../../components/atoms/Layout";
import { PasswordInput } from "../../components/atoms/AppInputs";

import { appAxios } from "../../utils/appAxios";
import { Button, useToast, VStack } from "@chakra-ui/react";

import { useToastMessage } from "../../hooks/useToastMessage";
import { useTranslation } from "react-i18next";

import { BannerImage } from "../../components/atoms/BannerImage";
import { passwordFlagAtom } from "../../store";
import { useAtom } from "jotai";

export function PasswordChangeForm(): ReactElement {
  const { t } = useTranslation();
  const toastError = useToastMessage();
  const toast = useToast();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [confirmationPassword, setConfirmationPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [, setPasswordFlag] = useAtom(passwordFlagAtom);

  // ボタン押下時の処理
  const onSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await appAxios.put("/account/password", {
        new_password: newPassword,
      });
      toast({
        status: "success",
        title: t("PasswordReset.NewPassword.success"),
      });
      setPasswordFlag(true);
      navigate("../home");
    } catch (e) {
      console.error("Chage Password Error!", e);
      toastError(e);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Layout>
      <BannerImage />
      <Layout.Title>{t("PasswordReset.NewPassword.title")}</Layout.Title>
      <form onSubmit={onSubmit}>
        <VStack spacing={8} mt={8}>
          <PasswordInput
            input={{
              placeholder: t("PasswordReset.NewPassword.input"),
              value: newPassword,
              onChange: (e) => setNewPassword(e.target.value),
            }}
          />
          <PasswordInput
            input={{
              placeholder: t("PasswordReset.NewPassword.confirm"),
              value: confirmationPassword,
              onChange: (e) => setConfirmationPassword(e.target.value),
            }}
          />
          <Button
            type="submit"
            variant="btn_primary"
            isLoading={isSubmitting}
            disabled={!newPassword || newPassword !== confirmationPassword}
            w="full"
          >
            {t("PasswordReset.NewPassword.submit")}
          </Button>
        </VStack>
      </form>
    </Layout>
  );
}
